import React from 'react';

import { useInfiniteQueryAllInvoicesHook } from '@fd/customHooks/useInfiniteQueryAllInvoices';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import { Translate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { useLocation } from 'react-router';
import { compose } from 'recompose';

import { getSelectedApp } from '../../../selectors/app.selector';
import LinkButton from '../../../ui/Button/LinkButton';

const useStyles = makeStyles(({ spacing, breakpoints }: Theme) => ({
  paperWrapper: {
    backgroundColor: '#ffbc2c',
    marginBottom: '16px',
  },
  invoiceBanner: {
    borderRadius: '8px',
    [breakpoints.down('xs')]: {
      alignContent: 'flex-start',
      marginLeft: spacing(2),
      marginRight: spacing(2),
      width: '93%',
    },
  },
}));

type InnerProps = MappedState;
type OuterProps = { overdueInvoices?: (string | undefined)[] };
type Props = InnerProps & OuterProps;

const AlertBannerBilling = (props: Props) => {
  const { appId, overdueInvoices: overdueInvoicesParent } = props;
  const classes = useStyles();
  const location = useLocation();

  const { overdueInvoices } = useInfiniteQueryAllInvoicesHook({
    appId: appId,
    isEnabled: !overdueInvoicesParent,
  });

  const toUrl = `/${appId}/billing/invoices`;

  const showBtnIfNoMatchUrl = location.pathname !== toUrl;

  return (
    <>
      {(overdueInvoices?.length > 0 ||
        (overdueInvoicesParent && overdueInvoicesParent?.length > 0)) && (
        <Grid
          container
          alignItems="flex-start"
          className={clsx(classes.invoiceBanner, classes.paperWrapper)}
        >
          <Grid item xs={12}>
            <Toolbar>
              <Typography variant="body2" color="textPrimary">
                <Translate id="You_have_1_or_more_invoices_overdue_payment" />
              </Typography>

              <div style={{ flexGrow: 1 }} />
              {showBtnIfNoMatchUrl && (
                <Hidden xsDown>
                  <LinkButton
                    variant="text"
                    color="primary"
                    to={toUrl}
                    type="button"
                    fdKey="Go_to_invoices_btn"
                    style={{ letterSpacing: '1.25px' }}
                  >
                    <Translate id="Go_to_invoices" />
                  </LinkButton>
                </Hidden>
              )}
            </Toolbar>
          </Grid>

          {showBtnIfNoMatchUrl && (
            <Hidden smUp>
              <Grid item xs={12}>
                <Box ml={1} mr={2} mb={1}>
                  <LinkButton
                    variant="text"
                    color="primary"
                    to={toUrl}
                    type="button"
                    fdKey="Go_to_invoices_btn"
                    style={{ letterSpacing: '1.25px' }}
                  >
                    <Translate id="Go_to_invoices" />
                  </LinkButton>
                </Box>
              </Grid>
            </Hidden>
          )}
        </Grid>
      )}
    </>
  );
};
type MappedState = ReturnType<typeof mapStateToProps>;
const mapStateToProps = (state: AppState) => ({
  appId: getSelectedApp(state).AppId!,
});

export default compose<InnerProps, OuterProps>(connect(mapStateToProps, {}))(AlertBannerBilling);
